import * as appRouting from "appRouting";
import { actions } from 'react-redux-form';
import * as authenticationApi from "user/authentication/api";
// Actions \ Action Creators
import * as userActions from "user/user/actions";
import * as authDomain from "user/authentication/Authentication";
import { notifier } from "common/notifier";
import * as formHelpers from "common/utils/formHelpers";
//-------------------------------------------------------------------------------------------------------------------------------
// Login
//-------------------------------------------------------------------------------------------------------------------------------
export const login = (dto, redirectUrl) => {
    return (dispatch) => {
        formHelpers.formAsynSubmit(dispatch, authDomain.pathsLogin.modelPath, authenticationApi.async_Login(dispatch, dto), (dispatch) => {
            // Create a user
            dispatch(userActions.createAction_User_Login(dto.mobile));
            // Update path
            if (redirectUrl) {
                appRouting.redirectTo(dispatch, redirectUrl);
            }
            else {
                appRouting.redirectTo(dispatch, appRouting.homePath());
            }
        }, (dispatch) => dispatch(actions.setPending(authDomain.pathsLogin.modelPath, false)));
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
// Logout
//-------------------------------------------------------------------------------------------------------------------------------
export const logout = () => {
    return (dispatch) => {
        authenticationApi.async_logout(dispatch)
            .then(() => {
            // update path
            appRouting.loginNavigate(dispatch);
            // Clear user data
            dispatch(userActions.createAction_User_Logout());
        })
            .catch((message) => {
            notifier.notifyError("Error", "Error logging out, please try again.");
        });
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
// Verify
//-------------------------------------------------------------------------------------------------------------------------------
export const initialiseVerifyMobile = (mobile) => {
    return (dispatch) => {
        dispatch(actions.change(authDomain.pathsVerify.mobile, mobile));
    };
};
export const verifyRequest = (dto) => {
    return (dispatch) => {
        formHelpers.formAsynSubmit(dispatch, authDomain.pathsRequestVerify.modelPath, authenticationApi.async_requestVerify(dispatch, dto), (dispatch) => {
            appRouting.verifyNavigate(dispatch);
        }, (dispatch) => dispatch(actions.setPending(authDomain.pathsRequestVerify.modelPath, false)), true, 0);
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
export function verify(dto) {
    return (dispatch) => {
        formHelpers.formAsynSubmit(dispatch, authDomain.pathsVerify.modelPath, authenticationApi.async_verify(dispatch, dto), (dispatch) => appRouting.homeNavigate(dispatch), (dispatch) => dispatch(actions.setPending(authDomain.pathsVerify.modelPath, false)));
    };
}
//-------------------------------------------------------------------------------------------------------------------------------
// Forgot
//-------------------------------------------------------------------------------------------------------------------------------
export const forgotPassword = (dto) => {
    return (dispatch) => {
        formHelpers.formAsynSubmit(dispatch, authDomain.pathsForgotPassword.modelPath, authenticationApi.async_forgotPassword(dispatch, dto), (dispatch) => appRouting.resetPasswordNavigate(dispatch), (dispatch) => dispatch(actions.setPending(authDomain.pathsForgotPassword.modelPath, false)));
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
export const initialiseResetMobile = (mobile) => {
    return (dispatch) => {
        dispatch(actions.change(authDomain.pathsResetPassword.mobile, mobile));
    };
};
export function forgotPasswordResetFromOtp(dto) {
    return (dispatch) => {
        formHelpers.formAsynSubmit(dispatch, authDomain.pathsResetPassword.modelPath, authenticationApi.async_resetPassword(dispatch, dto), (dispatch) => appRouting.homeNavigate(dispatch), (dispatch) => dispatch(actions.setPending(authDomain.pathsResetPassword.modelPath, false)));
    };
}
//-------------------------------------------------------------------------------------------------------------------------------
